<template>
    <main-content>
        <kt-panel>
            <kt-panel-body>
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <kt-form-group v-if="status === 'successNamadDetails'">
                        <kt-form-label class="form-group">
                            {{ $t('panel.profile.nav.using_namad') }}
                        </kt-form-label>
                        <kt-row>
                            <kt-col lg="6" md="6" xs="12">
                                 <textarea
                                         id="namad"
                                         v-if="namadGatewayDetails"
                                         class="col-lg-12 col-md-12 col-sm-6 namad_text_area"
                                         disabled dir="ltr">
                                 </textarea>
                            </kt-col>
                            <kt-col lg="6" md="6" xs="12" class="text-center" v-if="namadGatewayDetails">
                                <button type="button" @click="namadLink" id="btn_namad" class="no-border">
                                    <img :src="getNamadImage()" style="max-width:150px; max-height:150px" alt="namad">
                                </button>
                            </kt-col>

                        </kt-row>
                    </kt-form-group>
                </div>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>

    import mainContent from '@/components/main-content'
    import $ from "jquery";
    import { mapGetters } from "vuex";

    export default {
        components: {
            'main-content': mainContent
        },
        computed: {
            ...mapGetters('gateway', [
                'namadGatewayDetails', 'status'
            ])
        },
        mounted() {
            this.$store.dispatch('gateway/fetchNamad', this.$route.params.gateway_id).then(response =>{
                this.loadNamad()
            })
        },
        methods: {
            loadNamad() {
                if(this.namadGatewayDetails) {
                    let p1 = '<div><a href="javascript:getNamadLink()"><img src="';
                    let p2 = ' alt="namad"></a></div><script>function getNamadLink(){';
                    $('#namad').val(
                        p1 + this.namadGatewayDetails.namad_logo + '"' +
                        p2 + 'window.open(' + '"' + window.location.origin +
                        "/namad/" + this.$route.params.gateway_id + '"' + "," +
                        '"_blank"' + ',' +
                        ' "location=yes,height=570,width=520,scrollbars=yes,status=yes" ' +
                        ')}'+
                        '<'+'/'+'script'+'>'
                    )
                }
            },
            getNamadImage() {
                if(this.status === 'successNamadDetails') {
                    return this.namadGatewayDetails.namad_logo
                }
            },
            namadLink() {
               return window.open(window.location.origin + '/namad/' + this.$route.params.gateway_id, '_blank',
                'location=yes,height=570,width=520,scrollbars=yes,status=yes');
            }
        }
    }
</script>

<style>
.namad_text_area{
    min-height: 80px;
}
    .no-border{
        border: none;
        background: none;
    }
</style>